import { AxiosError } from "axios";
import { useState } from "react";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";

import {
  healthSignInDataType,
  IHealthData,
} from "../../models/auth/healthSignin/healthSignin.model";
import {
  ErrorHttpResponse,
  HttpConfig,
  SuccessHttpResponse,
} from "../../models/https";
import { authActions } from "../../redux/slices/authSlice";
import { useAppDisPatch } from "../../redux/store";
import useHttps from "../useHttps";

const useHealthSignin = () => {
  const navigate = useNavigate();
  const request = useHttps();
  const [loading, setLoading] = useState(false);
  const dispatch = useAppDisPatch();

  const setAuthentication = ({ data }: SuccessHttpResponse<IHealthData>) => {
    dispatch(
      authActions.setAuthentication({ authData: data, isAuthenticated: true })
    );
    localStorage.setItem("authData", JSON.stringify(data));
    toast.success("Login successful!", {
      duration: 3000,
    });
      navigate("/", { replace: true });
  };

  const onSignInError = (err: AxiosError<ErrorHttpResponse>) => {
    console.log("onLoginError");
    toast.error(err?.response?.data?.message ?? "Something went wrong");
  };

  const signinHealth = (data: healthSignInDataType) => {
    const url: HttpConfig = {
      url: "auth-service/institution/signin",
      method: "post",
      data,
    };

    request(url, setAuthentication, setLoading, onSignInError);
  };

  return {
    loading,
    signinHealth,
  };
};

export default useHealthSignin;
